import "../styles/HeaderHomeOut.css";
import condicionesGenerales from "../../../../assets/docs/Condiciones Generales.pdf";

const HeadHomeOut = () => {
  const downloadCondicionesGenerales = () => {
    const downloadLink = document.createElement("a");
    downloadLink.href = condicionesGenerales;
    downloadLink.download = "Condiciones Generales.pdf";
    downloadLink.click();
  };

  return (
    <>
      <div className="container-fluid banner pe-0 ps-0 d-block d-lg-none">
        {/* <div className="container-xxl pe-0 ps-0"> */}
        <div className="row me-0">
          <div className="col-12 col-md-6 pt-lg-4 pe-0">
            <div style={{ backgroundColor: "#91DDF8" }}>
              <img
                src="/assets/img/homeout/img-banner-homeoutheader.webp"
                className="banner__image d-block d-md-none"
                alt=""
              />
            </div>
            <div className="banner__text__center">
              <h5 className="banner__title">
                <b>¡Bienvenido!</b>
              </h5>
              <p className="banner__text pe-3 mt-3 pb-3">
                Conozcamos juntos todo lo relacionado con tu Seguro de Apoyo
                para Gastos Médicos.
              </p>
              <button
                className="banner__button"
                onClick={downloadCondicionesGenerales}
              >
                DESCARGAR CONDICIONES GENERALES
              </button>
            </div>

            <div className="banner__footer align-items-center d-flex d-md-none">
              <div className="cps-5 banner__footer__text pe-3">
                <p>
                  Llama sin costo{" "}
                  <span>
                    <b>
                      <a
                        href="tel:8005220973"
                        style={{ fontFamily: "var(--fuente-bold)" }}
                      >
                        800 522 0973
                      </a>
                    </b>
                  </span>
                </p>
                <p>Horarios de atención: Lun - vie de 08:00 a 21:00 hrs.</p>
                <p>
                  <b>
                    <a
                      href="mailto:middleoffice@cardif.com.mx"
                      style={{ fontFamily: "var(--fuente-bold)" }}
                    >
                      middleoffice@cardif.com.mx
                    </a>
                  </b>
                </p>
              </div>
            </div>
          </div>
          <div className="col-md-6 d-none d-md-block pe-lg-0">
            <img
              src="/assets/img/homeout/img-banner-homeoutheader.webp"
              className="banner__image"
              alt=""
            />
          </div>
        </div>

        <div
          className="row banner__footer d-none d-md-flex ms-0 me-0"
          style={{ backgroundColor: "#F7F7F7", color: "#000000" }}
        >
          <div className="col-12">
            <div className="row align-items-center">
              <div
                className="col-9 ps-5 banner__footer__text"
                style={{ borderRight: "1px solid #000000" }}
              >
                <p className="">
                  Llama sin costo{" "}
                  <span className="ps-3 pe-3">
                    <b>
                      <a
                        href="tel:8005220973"
                        style={{ fontFamily: "var(--fuente-bold)" }}
                      >
                        800 522 0973
                      </a>
                    </b>
                  </span>
                </p>
                <p className="pe-3">
                  Horarios de atención: Lunes a viernes de 08:00 a 20:00 hrs.
                </p>
                <p></p>
                <p></p>
              </div>
              <div className="col-3 text-center">
                <p>
                  <a
                    href="mailto:middleoffice@cardif.com.mx"
                    style={{ fontFamily: "var(--fuente-bold)" }}
                  >
                    middleoffice@cardif.com.mx
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
        {/* </div> */}
      </div>
      <div className="home p-0 d-none d-lg-block">
        <div className="container-cookie bannerInicial">
          <div className="row bannerI">
            <div className="col-12 col-md-6 col-back">
              <div className="home__text-container">
                <div className="home__title mb-5">
                  <h2>¡Bienvenido!</h2>
                </div>

                <div className="home__text mb-5">
                  <p className="mb-0 pb-5" style={{ lineHeight: "1.2" }}>
                    Conozcamos juntos todo lo relacionado <br />
                    con tu Seguro de Apoyo para Gastos Médicos
                  </p>
                </div>
                <button
                  className="btn__azul mt-5"
                  style={{ width: "330px", padding: "1rem 2rem" }}
                  onClick={downloadCondicionesGenerales}
                >
                  DESCARGAR CONDICIONES GENERALES
                </button>
              </div>
            </div>

            <div className="col-12 col-md-6 col-image p-0">
              <div className="home__image-container">
                <img
                  src="/assets/img/homeout/img-banner-homeoutheader.webp"
                  className="home__image_desks"
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="head__footer d-none d-lg-grid">
        <p> Llama sin costo: </p>
        <p>
          <b>
            <a
              href="tel:8005220973"
              style={{ fontFamily: "var(--fuente-bold)" }}
            >
              800 522 0973
            </a>
          </b>
        </p>
        <div className="separacion"></div>
        <p>Horarios de atención: Lunes a viernes de 08:00 a 21:00 hrs.</p>
        <div className="separacion"></div>
        <p>
          <b>
            <a
              href="mailto:middleoffice@cardif.com.mx"
              style={{ fontFamily: "var(--fuente-bold)" }}
            >
              middleoffice@cardif.com.mx
            </a>
          </b>
        </p>
      </div>
    </>
  );
};

export default HeadHomeOut;
